import { array, string } from 'fp-ts';

export const isValidCombination = ({
    validCombinations,
    selectedValues,
}: {
    validCombinations: string[][];
    selectedValues: string[];
}) =>
    validCombinations.some((validCombination) =>
        array.getEq(string.Eq).equals(validCombination.sort(), selectedValues.sort())
    );
